module.exports = __webpack_public_path__ + "media/images/ui-onboard/unboard-73cec6f8dcd656896cbcb8c032e7546b.svg";